import React, {useEffect, useState} from "react";
import _ from "lodash";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import {CAMPAIGN_INPUT_FIELDS} from "../../constants/campaign.constant";
import {
    addSingleCampaign,
    saveSingleCampaign,
    updateSingleCampaign
} from "../../services/facebook-campaign-data.service";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import RenderFields from "../../../common/ui/render-fields";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {createCampaign} from "../../services/facebook-ads-service";

const DEFAULT_CAMPAIGN: any = {
    name: '',
    objective: 'OUTCOME_TRAFFIC',
    status: 'PAUSED',
    specialAdCategories: [],
}

const AddEditCampaign = ({
                             selectedCampaign = {},
                             refreshCampaignList = undefined,
                             isAddCampaign = false,
                             isEditCampaign = false,
                             parentProduct = undefined,
                         }) => {
    const [showModal, setShowModal] = useState(false);
    const [campaign, setCampaign] = useState(selectedCampaign as any);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [campaignFieldInputs, setCampaignFieldInputs] = useState(CAMPAIGN_INPUT_FIELDS);

    useEffect(() => {

        if (showModal) {
            if (isEditCampaign) {
                setCampaign(selectedCampaign);
            } else {
                if (parentProduct) {
                    const newCampaign = {...DEFAULT_CAMPAIGN};
                    newCampaign.name = parentProduct?.name;
                    newCampaign.parentProductId = parentProduct?.id;
                    newCampaign.parentProduct = parentProduct?.name;
                    newCampaign.productType = parentProduct?.productType;
                    newCampaign.category = parentProduct?.category;

                    setCampaign(newCampaign);
                } else {
                    setCampaign(DEFAULT_CAMPAIGN);
                }
            }
        }

    }, [showModal]);

    const handleConfirmAction = async () => {
        setSaveInProgress(true);

        const existingCampaign: any = {...campaign};

        if (existingCampaign && !existingCampaign?.campaignId) {
            const createdCampaign: any = await createCampaign(existingCampaign?.name, existingCampaign?.objective);
            existingCampaign.campaignId = createdCampaign?.id;
            existingCampaign.id = createdCampaign?.id;
        }

        await saveSingleCampaign(existingCampaign);

        setSaveInProgress(false);
        setShowModal(false);

        if (refreshCampaignList) {
            refreshCampaignList();
        }
    }

    const handleCampaignChanges = (event) => {
        let existingCampaign = {...campaign};
        existingCampaign = handleFieldValueChanges(event, existingCampaign);
        setCampaign(existingCampaign);
    }

    const handleCloseAction = () => {
        setShowModal(false);
    }

    return (
        <>
            {isAddCampaign &&
                <button
                    className="button-purple px-2 py-1"
                    onClick={() => setShowModal(true)}>
                    Add Campaign
                </button>
            }

            {isEditCampaign &&
                <button
                    className="button-purple-outline px-3 py-1"
                    onClick={() => setShowModal(true)}>
                    Edit Campaign
                </button>
            }

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-1/2 my-6 mx-auto max-w-3xl">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        {isAddCampaign &&
                                            <>Add Campaign</>
                                        }

                                        {isEditCampaign &&
                                            <>Edit Campaign</>
                                        }
                                    </h3>

                                    <div className="">
                                        <button
                                            className="button-gray-outline px-1 py-1"
                                            onClick={handleCloseAction}>
                                            <div className="">
                                                <XMarkIcon className="h-6 w-6"/>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                {/*body*/}
                                <div className="relative p-5 flex-auto">
                                    <div className="leading-relaxed">

                                        {campaign?.parentProductId &&
                                            <div className={'mx-2 mb-4'}>
                                                <div className="flex flex-wrap justify-start">
                                                    <div className="w-32 font-bold">
                                                        Parent Product
                                                    </div>
                                                    <div className="">
                                                        {campaign?.parentProduct}
                                                    </div>
                                                </div>

                                                <div className="flex flex-wrap justify-start">
                                                    <div className="w-32 font-bold">
                                                        Product Type
                                                    </div>
                                                    <div className="">
                                                        {campaign?.productType}
                                                    </div>
                                                </div>

                                                <div className="flex flex-wrap justify-start">
                                                    <div className="w-32 font-bold">
                                                        Category
                                                    </div>
                                                    <div className="">
                                                        {campaign?.category}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        
                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={campaign}
                                                handleDetailChanges={handleCampaignChanges}
                                                fieldList={_.groupBy(campaignFieldInputs, 'group')['detail']}
                                                enableEdit={true}
                                                fieldClassName={'w-full'}/>
                                        </div>

                                        <div className="flex flex-wrap justify-start">
                                            <RenderFields
                                                parentForm={campaign}
                                                handleDetailChanges={handleCampaignChanges}
                                                fieldList={_.groupBy(campaignFieldInputs, 'group')['filter']}
                                                enableEdit={true}
                                                fieldClassName={'w-1/2'}/>
                                        </div>
                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                    <div className="ml-4 -mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                    </div>
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-8 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-8 px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Campaign
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default AddEditCampaign
